import { respondTo } from '@legacy-vfuk/core-mixins';
import styled, { css } from 'styled-components';

export const DrawerFilterContainer = styled.div`
  padding: 3rem;

  [class*='FieldWrapperstyle__Label-sc-'] {
    font-weight: 700;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AppliedFiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TopicWrapper = styled.div<{ boldLabels: boolean }>`
${props =>
    props.boldLabels
    && css`
    [class*='Checkboxstyle__CheckboxLabel-sc'] {
      font-weight: 700;
    }

    [class*='CheckboxFieldSetstyle__ChildCheckboxWrapper-sc'] {
      [class*='Checkboxstyle__CheckboxLabel-sc'] {
        font-weight: 400 !important;
      }
    }`
  }
`;

export const ClearFiltersLink = styled.div`
  cursor: pointer;
  user-select: none;
`;

export const ButtonGroupContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.625rem;

  flex-direction: column-reverse;
  ${respondTo.lg(css`
    flex-direction: row;
  `)}
`;

export const DrawerCheckboxSectionWrapper = styled.div`
overflow-x: scroll;
max-height: calc(100vh / 3);

@media screen and (max-height: 699px) {
  max-height: calc(100vh / 5);
}
`;
